import React from 'react';
import { InputBase, Typography } from "@mui/material";
import Div from "@jumbo/shared/Div";
import ReactInputMask from 'react-input-mask';

const InputMask = ({
  mask=null,
  disabled=false,
  value="",
  placeholder, 
  sx, 
  inputLabel,
  size,
  onChange,
  onBlur,
  type='text',
  required = false,
  name
}) => {   
  return (
    <Div sx={{
        position: 'relative',
        width: '100%',
        ...sx
    }}>
      <Typography variant={"body1"} fontWeight={500} mb={1} fontSize={12}>{inputLabel}{required && <span style={{ fontWeight: 'bold', fontSize: 14, color: 'red' }}> *</span>}</Typography>
      <Div sx={{position: 'relative'}}>
        <ReactInputMask mask={mask} value={value} onChange={onChange} disabled={disabled}>
          {(inputProps) => 
            <InputBase 
              {...inputProps}
              name={name}
              placeholder={placeholder} 
              onChange={onChange}
              onFocusCapture={onBlur}
              fullWidth
              type={type}
              size={size}
              sx={{
                color: 'inherit',
                display: 'flex',
                backgroundColor: disabled ? '#eee' : '#FFFFFF',
                borderRadius: '8px',
                '& .MuiInputBase-input': {
                    padding: theme => theme.spacing(1, 1, 1, 0),
                    paddingLeft: theme => `calc(1em + ${theme.spacing(1)})`,
                    paddingRight: theme => `calc(1em + ${theme.spacing(1)})`,
                    transition: theme => theme.transitions.create('width'),
                    width: '100%',
                    height: size == 'small' ? 19 : 30,
                    border: "1px solid #ADADAD",
                    borderRadius: 2,
                    fontSize: size == 'small' ? 12 : 12,
                    fontWeight: 600
                },
                '&.Mui-focused .MuiInputBase-input': {
                    border: "1px solid #4285F4",
                },
              }}
            />
          }
        </ReactInputMask>
      </Div>
    </Div>
  );
};

export default InputMask;
